export const Z_RULER = 100

export const RULER_HEIGHT = 30
export const CARD_HEIGHT = 32
export const ROW_HEIGHT = CARD_HEIGHT
export const HOUR_WIDTH = 120
export const PARENT_GROUP_ROW_HEAD = 120
export const CHILD_GROUP_ROW_HEAD = 120
export const ROW_HEAD_WIDTH = PARENT_GROUP_ROW_HEAD + CHILD_GROUP_ROW_HEAD
export const GROUP_GUTTER = 4
export const CARD_END_GUTTER = 2
